<template>
  <router-view />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',

  computed: {
    ...mapGetters(['getCustomCSS']),
  },

  watch: {
    getCustomCSS: {
      immediate: true,
      handler(css) {
        this.injectCustomCSS(css || '')
      },
    }
  },

  methods: {
    injectCustomCSS(cssString) {
      let styleTag = document.getElementById('custom-theme')
      if (!styleTag) {
        styleTag = document.createElement('style')
        styleTag.id = 'custom-theme'
        styleTag.setAttribute('type', 'text/css')
        document.head.appendChild(styleTag)
      }
      // Оновлюємо вміст
      styleTag.innerHTML = cssString
    }
  }
}
</script>

<style lang="scss">
body {
  overflow-x: scroll !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.Vue-Toastification__toast button {
  width: 10px;
}
</style>
